import axios from 'axios';
import userApi from '../api/user-api';

const headers = {
  'Accept': 'application/json',
  'Content-Type': 'application/json',
}

const addInterceptor = () => {
  getTokens();
  axios.interceptors.request.use(
    config => {
      config.headers = headers;
      return config;
    },
    error => Promise.reject(error)
  );

  axios.interceptors.response.use(
    response => {
      return response;
    },
    error => {
      console.log('error catched in interceptor: ', error.response)
      //try a refresh token
      var originalError= error;
      if (error.config && error.response) {
        console.log('-------------- TOKEN ERRORRR --------------');
        console.log(error);
        return userApi.refreshToken()
          .then(response => {
              const token = response.data.token;
              const accessToken = response.data.accessToken;
              //const refreshToken = response.refreshToken;
              interceptor.addValue('accessToken', accessToken);
              //Refresh token must not be updated
              interceptor.addToken(token);
              //now retry the request
              return axios.request(originalError.config);
          })
          .catch(error => {
              console.log(originalError);
              return new Promise((resolve, reject) => {
                reject(originalError);
              });
          })
      }
      
        
        return new Promise((resolve, reject) => {
          reject(error);
      });
    }
  );
}

const getTokens = ()  => { //TODO [PR]: Change the name of the function or do not set the token in the headers
  const token = localStorage.getItem('token');
  //console.log('Token for request:' + token);
  if (token !== null) {
      headers.Authorization = 'Bearer ' + token;
  }

}

const addToken = (token) => {
  localStorage.setItem('token', token);
  addInterceptor();
}

const addValue = (name,value ) => {
  localStorage.setItem(name, value);
  addInterceptor();
}

const getValue = (name) => {
  return localStorage.getItem(name);  
}

const removeTokens = () => {
  localStorage.removeItem('token');
  localStorage.removeItem('refreshToken');
  localStorage.removeItem('accessToken');
  addInterceptor();
}

export const interceptor = {
  addInterceptor,
  addToken,
  addValue,
  getValue,
  removeTokens
}
